import { EFileStatusAction } from "./efile-status-action.model";
import { IEFileDisplayStatus, IEFileStatus } from "./efile-status.interface";

export class EFileValidationStatus implements IEFileStatus {

    static readonly VirusFound = new EFileValidationStatus("virus-found", 100);
    static readonly NoVirusFound = new EFileValidationStatus("no-virus-found", 200);
    static readonly Processing = new EFileValidationStatus("processing", 300);
    static readonly TechnicalError = new EFileValidationStatus("technical-error", 350);
    static readonly Validating = new EFileValidationStatus("validating", 400);
    static readonly ValidationFailed = new EFileValidationStatus("validation-failed", 500);
    static readonly PartiallyValidated = new EFileValidationStatus("partially-validated", 550);
    static readonly SuccessfullyValidated = new EFileValidationStatus("validated-successfully", 600);

    private constructor(public readonly status: string, public readonly index: number) {
    }
}

export class EFileValidationDisplayStatus implements IEFileDisplayStatus {

    static readonly VirusFound = new EFileValidationDisplayStatus([EFileValidationStatus.VirusFound], "Virus found", "danger");
    static readonly NoVirusFound = new EFileValidationDisplayStatus([EFileValidationStatus.NoVirusFound], "Pending", "secondary", false);
    static readonly Processing = new EFileValidationDisplayStatus([EFileValidationStatus.Processing], "Processing", "info");
    static readonly TechnicalError = new EFileValidationDisplayStatus([EFileValidationStatus.TechnicalError], "Technical error", "danger", true, EFileStatusAction.ReUpload);
    static readonly Validating = new EFileValidationDisplayStatus([EFileValidationStatus.Validating], "Validating", "info");
    static readonly ValidationFailed = new EFileValidationDisplayStatus([EFileValidationStatus.ValidationFailed], "Validation failed", "danger", true, EFileStatusAction.ReUpload);
    static readonly PartiallyValidated = new EFileValidationDisplayStatus([EFileValidationStatus.PartiallyValidated], "Partially validated", "danger", true, EFileStatusAction.ReUpload);
    static readonly SuccessfullyValidated = new EFileValidationDisplayStatus([EFileValidationStatus.SuccessfullyValidated], "Successfully validated", "success");

    private constructor(public readonly statusses: EFileValidationStatus[],  public readonly name: string, public readonly indicator: string, public readonly isVisibleInFilter: boolean = true,  public readonly action: EFileStatusAction = null) {

    }

    static readonly all = [
        EFileValidationDisplayStatus.Processing, 
        EFileValidationDisplayStatus.VirusFound, 
        EFileValidationDisplayStatus.NoVirusFound, 
        EFileValidationDisplayStatus.Validating, 
        EFileValidationDisplayStatus.TechnicalError, 
        EFileValidationDisplayStatus.ValidationFailed, 
        EFileValidationDisplayStatus.PartiallyValidated, 
        EFileValidationDisplayStatus.SuccessfullyValidated 
    ];
    static readonly allVisibleInFilter = EFileValidationDisplayStatus.all.filter(x => x.isVisibleInFilter);

    static parse(status: string) : EFileValidationDisplayStatus{
        return EFileValidationDisplayStatus.all.find(x => x.statusses.some(s => s.status == status))
    }

    static parseAll(statusses: string[]) : EFileValidationDisplayStatus[] {
        return EFileValidationDisplayStatus.all.filter(x => x.statusses.some(s => statusses.some(status => s.status === status)));
    }
}